import { CheckedAddress, NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'
import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import { ProvidedBy } from '../common/types'
import { Token } from '@/domain/types/Token'
import { TxOutcome } from '@/features/actions/logic/types'

export type Mode = 'withdraw' | 'send'
export type SavingsType = 'sdai' | 'susds'

export const ReceiverFormSchema = z.object({
  receiver: z.string(),
})
export type ReceiverFormSchema = z.infer<typeof ReceiverFormSchema>

export interface TxOverview {
  underlyingToken: Token
  APY: Percentage
  stableEarnRate: NormalizedNumber
  outTokenAmount: NormalizedNumber
  providedBy: ProvidedBy
}

export type TxOverviewResult<T extends {}> =
  | {
      status: 'no-overview'
      providedBy: ProvidedBy
      savingsToken: Token
    }
  | ({
      status: 'success'
    } & T)

export type SavingsDialogTxOverview = TxOverviewResult<TxOverview>

export interface SendModeExtension {
  receiverForm: UseFormReturn<ReceiverFormSchema>
  receiver: CheckedAddress | undefined
  showReceiverIsSmartContractWarning: boolean
  blockExplorerAddressLink?: string
  enableActions: boolean
}

export type WithdrawFromSavingsTxOutcome = Extract<TxOutcome, { type: 'withdrawFromSavings' }>
export type ExtendedWithdrawFromSavingsTxOutcome = WithdrawFromSavingsTxOutcome & {
  savingsToken: Token
  underlyingToken: Token
  underlyingTokenAmountPaid: NormalizedNumber
  outputToken: Token
}

export type SavingsWithdrawTxOverview = TxOverviewResult<{
  providedBy: ProvidedBy
  savingsToken: Token
  underlyingToken: Token
  underlyingTokenDepositedBefore: NormalizedNumber
  underlyingTokenDepositedAfter: NormalizedNumber
  tokenToReceive: Token
  tokenToReceiveAmount: NormalizedNumber
  mode: { type: 'withdraw' } | { type: 'send'; receiver?: CheckedAddress }
}>
